// Soporte - Categoria  Soporte - Subcategoria
import {
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import Select from 'react-select';
import React, { useEffect, useState } from 'react';
import Structure from '../Structure';
import { Link, useParams } from 'react-router-dom';
import { Link as Enlace } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import data from '../../lib/backend/data';
import toast from 'react-hot-toast';
import { cerrarSesion } from '../../redux/actions/session';
import opcionesfecha from '../../lib/helpers/opcionesfecha';
import CamposObligatoriosLeyenda from '../../subcomponents/general/formularios/campos_requeridos_leyenda';

const SubSoporteCreate = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [loadingSelect, setLoadingSelect] = useState(true);
  const [selectOptions, setSelectOptions] = useState([]);
  const [subsoporte, setSubSoporte] = useState({});
  const sesion = useSelector((state) => state.miusuario);

  const handleChange = (e) => {
    const { name, value } = e.target;
    subsoporte[name] = value;
    return setSubSoporte({ ...{}, ...subsoporte });
  };

  const handleSelect = (e) => {
    subsoporte.parent = e.value;
    subsoporte.ref = e.label;
  };

  const crearSubSoporte = async () => {
    const requeridos = [{ value: 'titulo', label: 'Titulo' }];
    let faltantes = [];
    requeridos.map((campo) => {
      if (!subsoporte[campo.value]) faltantes.push(campo.label);
      return true;
    });
    if (faltantes.length > 0)
      return toast.error(`Faltan campos: ${faltantes.join(', ')}`);

    setLoading(true);
    return fetch(`${data.urlapi}/subsoporte`, {
      method: 'POST',
      body: JSON.stringify(subsoporte),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then((res) => {
        if (!res) {
          toast.error('Sin datos o no existe la categoria Soporte');
          return setLoading(false);
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
          return setLoading(false);
        } else if (res._id) {
          toast.success('Creado exitosamente');
          setTimeout(() => {
            return (window.location = `/subsoporte-${res._id}`);
          }, 500);
        }
        return setLoading(false);
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
        return setLoading(false);
      });
  };

  const opciones = (res) => {
    res.map((opcion) => {
      return selectOptions.push({ value: opcion._id, label: opcion.titulo_front });
    });
    setLoadingSelect(false);
    return selectOptions;
  };

  const obtenerSoportes = async () => {
    return fetch(`${data.urlapi}/soporte/list/select`, {
      method: 'POST',
      body: JSON.stringify({}),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer: ${sesion.tokenSession}`,
      },
    })
      .then((res) => {
        if (res.status === 401) return dispatch(cerrarSesion());
        return res.json();
      })
      .then(async (res) => {
        if (!res) {
          toast.error('Sin datos');
        } else if (res.errorMessage) {
          toast.error(res.errorMessage);
        } else if (res.length > 0) {
          opciones(res);
        } else if (res.length < 1) {
          setLoadingSelect(false);
          toast.error('No existen Categorias de Soportes.');
        }
      })
      .catch((error) => {
        toast.error('Error al consultar la información, intente nuevamente');
      });
  }

  useEffect(() => {
    obtenerSoportes();
  }, []);

  const render = () => {
    return (
      <div>
        <Breadcrumbs aria-label='breadcrumb'>
          <Link to='/subsoporte'>Categorías de soporte</Link>
          <Enlace underline='hover' color='text.primary'>
            Crear categoría de soporte
          </Enlace>
        </Breadcrumbs>
        <h1 style={{ margin: 0 }}>Crear categoría de soporte</h1>
        <CamposObligatoriosLeyenda />
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item md={3} xs={12}>
            <TextField
              label='Titulo'
              variant='filled'
              name='titulo'
              required
              fullWidth
              onChange={handleChange}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <InputLabel required>Categoría</InputLabel>
            <Select
              options={selectOptions}
              isLoading={loadingSelect}
              loadingMessage={() => 'Cargando'}
              noOptionsMessage={() => 'Sin opciones'}
              placeholder="Selecciona"
              label='Tipo'
              name='tipo'
              onChange={handleSelect}
              height={20}
            />
          </Grid>
          <Grid item md={12} xs={12}>
            {loading === true ? (
              <CircularProgress />
            ) : (
              <Button
                variant='contained'
                xs={{ m: 0 }}
                onClick={() => crearSubSoporte()}
              >
                CREAR
              </Button>
            )}
          </Grid>
        </Grid>
      </div>
    );
  };

  return <Structure component={render()} />;
};

export default SubSoporteCreate;
